import React from 'react';
import { Button as AntButton } from 'antd';
import PropTypes from 'prop-types';

export const Button = ({ 
  children, 
  variant = 'default', 
  type = 'default',
  color = 'default',
  size = 'middle',
  block = false,
  disabled = false,
  icon,
  onClick,
  htmlType = 'button',
  className = '',
  danger = false,
  ghost = false,
  shape,
  loading = false,
  style,
  ...props 
}) => {
  // Map color variants to styles
  const colorStyles = {
    success: {
      backgroundColor: '#52c41a',
      borderColor: '#52c41a',
      color: '#fff',
      '--ant-primary-color': '#52c41a',
      '--ant-primary-color-hover': '#73d13d',
      '&:hover': {
        backgroundColor: '#73d13d',
        borderColor: '#73d13d',
      }
    },
    warning: {
      backgroundColor: '#faad14',
      borderColor: '#faad14',
      color: '#fff',
      '--ant-primary-color': '#faad14',
      '--ant-primary-color-hover': '#ffc53d',
      '&:hover': {
        backgroundColor: '#ffc53d',
        borderColor: '#ffc53d',
      }
    },
    info: {
      backgroundColor: '#1677ff',
      borderColor: '#1677ff',
      color: '#fff',
      '--ant-primary-color': '#1677ff',
      '--ant-primary-color-hover': '#4096ff',
      '&:hover': {
        backgroundColor: '#4096ff',
        borderColor: '#4096ff',
      }
    },
    error: {
      backgroundColor: '#ff4d4f',
      borderColor: '#ff4d4f',
      color: '#fff',
      '--ant-primary-color': '#ff4d4f',
      '--ant-primary-color-hover': '#ff7875',
      '&:hover': {
        backgroundColor: '#ff7875',
        borderColor: '#ff7875',
      }
    },
    default: {}
  };

  // Get button type based on variant and type props
  const getButtonType = () => {
    if (variant === 'contained') return 'primary';
    if (variant === 'outlined') return 'default';
    if (variant === 'text') return 'link';
    return type;
  };

  // Get final style based on color and type
  const getFinalStyle = () => {
    if (color === 'default' || type === 'link' || type === 'text' || ghost) {
      return style;
    }
    return { ...colorStyles[color], ...style };
  };

  return (
    <AntButton
      type={getButtonType()}
      size={size}
      block={block}
      disabled={disabled}
      icon={icon}
      onClick={onClick}
      htmlType={htmlType}
      className={`custom-button-${color} ${className}`}
      danger={danger}
      ghost={ghost}
      shape={shape}
      loading={loading}
      style={getFinalStyle()}
      {...props}
    >
      {children}
    </AntButton>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text', 'default']),
  type: PropTypes.oneOf(['primary', 'default', 'dashed', 'link', 'text']),
  color: PropTypes.oneOf(['default', 'success', 'warning', 'info', 'error']),
  size: PropTypes.oneOf(['large', 'middle', 'small']),
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  htmlType: PropTypes.oneOf(['button', 'submit', 'reset']),
  className: PropTypes.string,
  danger: PropTypes.bool,
  ghost: PropTypes.bool,
  shape: PropTypes.oneOf(['default', 'circle', 'round']),
  loading: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      delay: PropTypes.number
    })
  ]),
  style: PropTypes.object,
};

export default Button; 